import { promiseWrapper } from 'utils/promise'

export type NewsletterPages = {
  thank_you_page: string
  newsletter_page: string
}

export const getPagesNewsletter = (): Promise<NewsletterPages> => {
  return promiseWrapper<NewsletterPages, never>(`${window.location.origin}/wp-json/newsletter/v1/pages`, 'GET')
}
